import Component from 'gia/Component'
import gsap from 'gsap'


class Form extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element

    this.ref = {
      form: null,
      button: null,
      status: null,
      error: null,
      wrap: null
    }


  }

  mount() {

    this.clas = this.ref.form.dataset.clas

    $('input', this.element).on('focus', () => {
      $(this.ref.error).removeClass('is-visible')
      $(this.ref.button).removeClass('is-sending')
    })

    this.ref.form.addEventListener("submit", (ev)=> {
      ev.preventDefault();
      $(this.ref.button).addClass('is-sending')

       const myForm = this.ref.form;
       const formData = new FormData(myForm);

      //var data = new FormData(this.ref.form);
      //this.ajax(this.ref.form.method, this.ref.form.action, data, this.success.bind(this), this.error.bind(this));

      fetch("/", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: new URLSearchParams(formData).toString(),
        })
        .then((e) => this.success(e))
        .catch((error) => this.error(error));


    });

  }

  success(e) {

    if(e.ok){

      this.ref.form.reset();
      this.body.hasClass(`has-${this.clas}`) && this.body.removeClass(`has-${this.clas}`).addClass(`has-${this.clas}-sent`)
      this.body.hasClass('has-contact-form') && this.body.removeClass('has-contact-form').addClass('has-contact-form-sent')
      $(this.ref.wrap).addClass('is-success')
      $(this.ref.status).addClass('is-visible')
      $(this.ref.error).removeClass('is-visible')
      $(this.ref.button).removeClass('is-sending')

    }

    else {
      this.error()
    }

    

  }

  error() {
    $(this.ref.wrap).addClass('is-sent')
    $(this.ref.error).addClass('is-visible')
  }





  unmount() {

  }


}

module.exports = Form
